import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import AppLogo from "@/features/ui/app-logo";
import AppSelect from "@/features/line-sheet-sets/app-select";
import AppButton from "@/features/line-sheet-sets/app-button";
import { getDefaultPageByIdentity } from "@/pages";
import { getIdentity } from "@/features/ui/helpers/identity-helpers";
import useRouterHelper from "@/features/ui/hooks/use-router-helper";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import { Trans } from "react-i18next";
import AppLanguageSelector from "@/features/ui/app-language-selector";

export default function _500Page() {
  const { navigate } = useRouterHelper();
  const { tTitle } = useI18nHelper();

  return (
    <Flex
      maxW="440px"
      w="100%"
      backgroundColor={"#FFF"}
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      border="0.5px solid #D4D4D1"
      borderRadius="8px"
      padding={"28px 0px"}
      gap="24px"
      position="relative"
    >
      <AppLogo />
      <Heading fontSize="64px" fontWeight={"700"} color={"#444444"}>
        500
      </Heading>
      <Text
        fontSize={"32px"}
        fontWeight={"700"}
        color={"#444444"}
        textAlign={"center"}
      >
        <Trans
          i18nKey={"error_page:500_title"}
          components={{
            br: <br />,
          }}
        />
      </Text>
      <Text
        padding={"0 80px"}
        fontSize={"14px"}
        textAlign={"center"}
        minHeight={"269px"}
      >
        <Trans
          i18nKey={"error_page:500_description"}
          components={{
            br: <br />,
          }}
        />
      </Text>
      {/*{socialButtons}*/}
      <Box width={"100%"} padding={"0 80px"}>
        <AppButton
          variant={"gray"}
          width={"100%"}
          size={"large"}
          height={"100%"}
          onClick={() => {
            navigate(getDefaultPageByIdentity(getIdentity()), {
              replace: true,
            });
          }}
        >
          {tTitle("error_page:go_home")}
        </AppButton>
      </Box>

      <Text fontSize={"12px"}>© UNO Trading Corp.</Text>
      <AppLanguageSelector />
    </Flex>
  );
}
